import { Box } from '@mui/material';
import React from 'react';

const BackgroundLetter = () => {
  return (
    <Box
      sx={{
        padding: 5,
        margin: 5,
        width: {
          lg: '50%',
        },
        border: '1px solid gray',
      }}
    >
      <h2 style={{ textAlign: 'center' }}>NMZ BACKGROUND CHECK PROCEDURE</h2>
      <p>Dear New Mt. Zion Member:</p>
      <p>
        Welcome to New Mt. Zion&apos;s Employment and Volunteer Verification
        System. New Mt. Zion Lakeland exists to share God&apos;s Word and His
        Love while serving as a Beacon of Light and Hope within the Lakeland
        Community. Employees and volunteers play an essential role in the
        operations of our church, and we appreciate and thank you for your
        interest in serving at New Mt. Zion Missionary Baptist Church Lakeland.
        As church-based Leadership, employees or volunteers, we require you to
        demonstrate Christian behavior and serve with compassion, excellence,
        and love for one another.
      </p>
      <p>
        The church requires all Deacons, Ministers, Trustees, employees and
        volunteers to complete an Employee/Volunteer application form and
        undergo a confidential electronic background check. Our church has
        partnered with Protect My Ministry, the leading background check firm in
        the nation, to ensure we have the right people in the right places and
        the best resources to protect our children, members, and church assets.
        As a convenience, the firm&apos;s ministry mobilizer is designed to
        assist the church in providing a one-stop verification process.
      </p>

      <h3 style={{ textAlign: 'center' }}>
        TRAINING FOR CHILDREN&apos;S MINISTRY VOLUNTEERS
      </h3>
      <p>
        In addition to the background check verification process, all
        Children&apos;s Ministry volunteers must complete the Child Safety
        Training Course before working in this ministry. This is non-negotiable.
        The <b>Child Safety Training Course</b> is completed online and consists
        of 5 lessons covering the following topics:
      </p>
      <ol type="a">
        <li>Lesson 1: Defining Child Sexual Abuse</li>
        <li>Lesson 2: Victim Behavioral Characteristics</li>
        <li>Lesson 3: Characteristics of Child Molesters</li>
        <li>Lesson 4: Making a Difference</li>
        <li>Lesson 5: Responsibility &amp; Reporting</li>
      </ol>
      <p>
        The Children&apos;s Church Child Safety Training Modules will be sent
        electronically to the Children&apos;s ministry volunteers after they
        successfully complete the background check.
      </p>

      <h3 style={{ textAlign: 'center' }}>THE APPLICATION PROCESS</h3>
      <p>
        Please click{' '}
        <a
          href="https://ministryopportunities.org/NMZLakeland"
          target="_blank"
          rel="noreferrer"
        >
          the link
        </a>
        {` `} below to complete the employment and Volunteer application form
        and give consent for a confidential electronic background check. Thank
        you again for your interest in serving our church. Please contact the
        church office with questions.
      </p>
      <p>
        <a
          href="https://ministryopportunities.org/NMZLakeland"
          target="_blank"
          rel="noreferrer"
        >
          Background Check &#8212; Employment and Volunteer Application
        </a>
      </p>
      <p>New Mt. Zion Lakeland Administration</p>
      <p>1321 N. Webster Avenue, Lakeland, FL 33805</p>
      <p>(863) 686-6793</p>
      <p>
        <a href="mailto:info@nmzlakeland.org">info@nmzlakeland.org</a>
      </p>
    </Box>
  );
};

export default BackgroundLetter;
